// Angulr
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { SlideMainComponent } from './main/slide-main.component';
import { SlideComponent } from './slide.component';

/**
 * Routes
 */
const routes: Routes = [
  {
    path: '',
    component: SlideComponent,
    children: [
      { path: '', component: SlideMainComponent }
    ]
  },
];

/**
 * Slide Routing Module
 */
@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class SlideRoutingModule {
}
